/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './backups.scss';

/* eslint-disable import/no-unresolved, import/default */

import backupsTemplate from './backups.tpl.html';
import createBackupTemplate from './create-backup.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('tektelic.gatewayBackups', [])
    .directive('tkGatewayBackups', GatewayBackups)
    .name;

/*@ngInject*/
function GatewayBackups() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            gatewayId: '=',
            isReadOnly: '='
        },
        controller: GatewayBackupsController,
        controllerAs: 'vm',
        templateUrl: backupsTemplate
    };
}

/*@ngInject*/
function GatewayBackupsController($rootScope, $scope, $element, $mdDialog, $document, toast, gatewayCommandService, $filter, $mdMedia, types) {

    var vm = this;

    vm.$onInit = function () {
        vm.types = types;

        vm.allBackups = [];
        vm.backups = [];
        vm.rowsCount = 0;
        vm.backupStatus = '';

        vm.query = {
            order: '-date',
            limit: 15,
            page: 1
        };

        vm.limitOptions =
            [15, 30, 45];

        vm.getBackups = getBackups;

        vm.onReorder = function () {
            updateBackups();
        };

        vm.onPaginate = function () {
            updateBackups();
        };

        vm.createBackup = createBackup;
        vm.restoreBackup = restoreBackup;

        vm.loading = function () {
            return $rootScope.loading;
        };
    };

    $scope.$watch(function () {
        return $mdMedia('gt-md');
    }, function (isGtMd) {
        vm.isGtMd = isGtMd;
        if (vm.isGtMd) {
            vm.limitOptions = [15, 30, 45];
        } else {
            vm.limitOptions = null;
        }
    });

    $scope.$watch('vm.gatewayId', (newVal) => {
        if (newVal) {
            reload();
        }
    });

    function reload() {
        vm.allBackups.length = 0;
        vm.backups.length = 0;
        vm.rowsCount = 0;
        vm.backupStatus = '';
    }

    function getBackups() {
        reload();
        vm.backupsPromise = gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.backupsGatewayCommand.getBackups.value, {});
        vm.backupsPromise.then(
            (backups) => {
                vm.allBackups = backups.backups;
                vm.backupStatus = backups.status;
                updateBackups();
            },
            (rejection) => {
                toast.showError(rejection.data, $element.closest(".toast-parent"), 'bottom left');
            }
        );
    }

    function updateBackups() {
        var result = $filter('orderBy')(vm.allBackups, vm.query.order);
        vm.rowsCount = result.length;
        var startIndex = vm.query.limit * (vm.query.page - 1);
        vm.backups = result.slice(startIndex, startIndex + vm.query.limit);
    }

    function createBackup($event) {
        if ($event) {
            $event.stopPropagation();
        }
        $mdDialog.show({
            controller: CreateBackupController,
            controllerAs: 'vm',
            templateUrl: createBackupTemplate,
            parent: angular.element($document[0].body),
            locals: {
                gatewayId: vm.gatewayId
            },
            fullscreen: true,
            skipHide: true,
            targetEvent: $event
        }).then(function () {
            getBackups();
        }, function () {
        });
    }

    function restoreBackup($event, backup) {
        vm.backupsPromise = gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.backupsGatewayCommand.restoreBackup.value, {index: backup.index}).then(
            () => {
                getBackups();
            },
            (rejection) => {
                toast.showError(rejection.data, $element.closest(".toast-parent"), 'bottom left');
            }
        );
    }
}

/*@ngInject*/
function CreateBackupController($rootScope, $scope, $mdDialog, $document, toast, types, gatewayCommandService, gatewayId) {

    var vm = this;

    vm.$onInit = function () {
        vm.gatewayId = gatewayId;

        vm.types = types;

        vm.description = '';

        vm.createBackup = createBackup;
        vm.cancel = cancel;

        vm.loading = function () {
            return $rootScope.loading;
        };
    };

    function cancel() {
        $mdDialog.cancel();
    }

    function createBackup() {
        gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.backupsGatewayCommand.createBackup.value, {description: vm.description}).then(
            () => {
                $scope.theForm.$setPristine();
                $mdDialog.hide();
            },
            (rejection) => {
                onError(rejection.data);
            }
        );
    }

    function onError(error) {
        var toastParent = angular.element('#tk-create-backup-dialog', $document);
        var dialogContent = toastParent.find('md-dialog-content');
        if (dialogContent.length > 0) {
            toastParent = dialogContent;
        }
        toast.showError(error, toastParent, 'bottom right');
    }

}



// WEBPACK FOOTER //
// ./src/app/gateway/backups/backups.directive.js